// extracted by mini-css-extract-plugin
export default {"emailInput":"EmailConfirmation_emailInput__S2rNy"};